import React from 'react';
import PropTypes from 'prop-types';
import generateRulesLink from 'utils/generateRulesLink';
import { Link, Text } from 'components';
import _ from 'lodash';
import { AboutSubscriptionStyled } from './styles/AboutSubscriptionStyled';

const AboutSubscription = ({ translate, subscriptionInfo }) => {
  const landingLink = _.get(subscriptionInfo, 'tariffs.0.landingLink', '').replace('/', '');
  return (
    <AboutSubscriptionStyled>
      <Text color="gray">
        {`${translate('first_month_price', {
          price: _.get(subscriptionInfo, 'tariffs.0.priceText'),
        })}, ${translate('next_month_price', {
          price: _.get(subscriptionInfo, 'tariffs.0.regularPriceText'),
        })} `}
        <Link href={landingLink ? generateRulesLink(landingLink) : generateRulesLink('')}>
          {translate('about_offer')}
        </Link>
      </Text>
    </AboutSubscriptionStyled>
  );
};

AboutSubscription.propTypes = {
  translate: PropTypes.func.isRequired,
  subscriptionInfo: PropTypes.object.isRequired,
};

export default AboutSubscription;
